import _ from "lodash";
import React from "react";

interface Props {
	name: string;
	children: React.ReactNode;
	className?: string;
}

export default function MenuItem({ children, name, className }: Props) {
	return (
		<li
			className={`menu__item menu__item--${_.toLower(name)} ${
				className ? className : ""
			}`}>
			{children}
		</li>
	);
}
